<template>
    <pwa_article :pwa="pwa" article_type="delivery"></pwa_article>
</template>

<script>
import pwa_article from "./pwa_article";
export default {
    name: "pwa_article_delivery",
    components : {
        pwa_article
    },
    props : {
        pwa : {
            type:Object
        }
    },
}
</script>

<style scoped>

</style>
